import { Button, Tooltip } from 'flowbite-react';
import { useCallback, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import Loader from '../Common/Loader';
import { useAppSelector } from '../../Reducers/store';
import EquipmentApi from '../../Api/EquipmentApi';
import { HiPlus } from 'react-icons/hi';
import EquipmentFilesTable from './EquipmentFilesTable';
import CommonApi from '../../Api/CommonApi';
import { File } from '../../Models/File';
import { FileTypeEnums } from '../../Models/FileType';
import AddFileModal from '../Common/AddFileModal';

export default function EquipmentFiles({
  equipmentId,
}: {
  equipmentId: number;
}) {
  const { userModel } = useAppSelector((state) => state.user);
  const [equipmentFiles, setEquipmentFiles] = useState<File[]>([]);
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [showAddFile, setShowAddFile] = useState<boolean>(false);

  const getEquipmentFiles = useCallback(() => {
    if (userModel) {
      try {
        setIsLoading(true);
        return EquipmentApi.getEquipmentFiles(equipmentId)
          .then((res) => {
            setEquipmentFiles(
              res.data.filter((x) => x.fileTypeId !== FileTypeEnums.Photo)
            );
            setIsLoading(false);
          })
          .catch((err) => {
            toast.error('Error');
            setIsLoading(false);
          });
      } catch (error) {
        console.error(error);
        toast.error('Error');
        setIsLoading(false);
      }
    }
  }, [userModel]);

  useEffect(() => {
    getEquipmentFiles();
  }, [getEquipmentFiles]);

  const handleAddEquipmentFileClick = () => {
    setSelectedFile(null);
    setShowAddFile(true);
  };

  const editFile = (file: File) => {
    setSelectedFile(file);
    setShowAddFile(true);
  };

  function deleteFile(id: number) {
    const shouldRemove = window.confirm(
      'Are you sure you want to delete this?'
    );

    if (shouldRemove) {
      CommonApi.deleteFile(id)
        .then((res) => {
          if (res.data.success) {
            toast.success(res.data.message);
            getEquipmentFiles();
          } else {
            toast.success('Error while deleting item');
          }
        })
        .catch((err) => {
          toast.error('Error: ' + err);
        });
    }
  }
  function checkAccess() {
    if (userModel) {
      return true;
    } else {
      return false;
    }
  }

  return (
    <>
      <div className='w-full'>
        {checkAccess() && (
          <div className='w-full flex justify-end'>
            <Tooltip content={`Add File`}>
              <Button
                onClick={handleAddEquipmentFileClick}
                className='buttonMain'
              >
                <HiPlus size={20} />
              </Button>
            </Tooltip>
          </div>
        )}
        <div className='w-full p-4'>
          {isLoading && <Loader />}
          <EquipmentFilesTable
            data={equipmentFiles}
            deleteFile={deleteFile}
            editFile={editFile}
          />
        </div>
      </div>
      <AddFileModal
        show={showAddFile}
        setShow={setShowAddFile}
        selectedFile={selectedFile}
        getEquipmentFiles={getEquipmentFiles}
        equipmentId={equipmentId}
      />
    </>
  );
}
